<template>
  <section class="content">
    <admin-header
      :title="'Port Areas'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminPortArea',
    data () {
      return {
        newEntityScreen: 'Admin - Port Areas',
        searchEntityScreen: 'Admin - Port Area search',
        filterEventName: 'admin-port-area-filter',
        filterName: 'PortAreaFilter',
        entityName: 'port-area'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/PortArea/AdminPortArea.vue